module.exports = __webpack_public_path__ + "img/product-m-val1.7d0545a2.png";